import React from 'react';

export interface DivisaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const DivisaIcon: React.FC<DivisaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.013 7.482v9.489m2.156-7.763h-3.235a1.51 1.51 0 0 0 0 3.019h2.157a1.51 1.51 0 1 1 0 3.019H9.425"/><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="M21.587 11.702a8.7 8.7 0 0 0-.532-2.539c-1.498-4.034-5.694-6.324-9.992-5.766M2.44 13.374a8.7 8.7 0 0 0 .53 2.508c1.494 4.023 5.672 6.312 9.958 5.77"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m23 9.055-1.414 2.646-2.413-1.842M1.025 16.016 2.44 13.37l2.367 1.8"/>
    </svg>
  );
};

export default DivisaIcon;
